import './Main/admin/admin.tpl.html';
import './Main/admin/adminCACM/adminCACM.tpl.html';
import './Main/admin/adminGovernanceProcess/adminGovernanceProcess.tpl.html';
import './Main/admin/adminGovernanceProcess/adminGovernanceProcessList.tpl.html';
import './Main/admin/adminGovernanceProcess/editGovernanceProcess.tpl.html';
import './Main/admin/adminODD/adminODD.tpl.html';
import './Main/admin/adminReferenceData/AdminReferenceData.tpl.html';
import './Main/admin/adminReferenceData/ItemTypeCard.tpl.html';
import './Main/admin/adminReferenceData/LookupAttributeCard.tpl.html';
import './Main/admin/adminReferenceData/LookupAttributeValueCard.tpl.html';
import './Main/admin/travelGovernanceProcess/travelGovernanceProcessEdit.tpl.html';
import './Main/admin/travelGovernanceProcess/travelGovernanceProcessList.tpl.html';
import './Main/aric/aric.tpl.html';
import './Main/aric/aricControlByOwnerItem.tpl.html';
import './Main/aric/aricControlOwnerCard.tpl.html';
import './Main/aric/aricControlOwnersList.tpl.html';
import './Main/aric/aricControlsByOwner.tpl.html';
import './Main/aric/certification/certification.tpl.html';
import './Main/aric/certification/completed.tpl.html';
import './Main/aric/certification/controlCertification.tpl.html';
import './Main/aric/certification/OwnerAssessment_Fraud.tpl.html';
import './Main/aric/certification/OwnerAssessment_Operational.tpl.html';
import './Main/aric/certification/OwnerAssessment_Responsibility.tpl.html';
import './Main/aric/certification/OwnerAssessment.tpl.html';
import './Main/aric/certification/welcome.tpl.html';
import './Main/aric/certification/withNoActiveProcess.tpl.html';
import './Main/aric/GOVHistoryCtxtDirective-aricControlOwner.tpl.html';
import './Main/aric/withNoActiveProcess.tpl.html';
import './Main/auditMandate/AuditMandateAdd.tpl.html';
import './Main/auditMandate/AuditMandateEdit.tpl.html';
import './Main/auditMandate/auditMandateObservationsList.tpl.html';
import './Main/auditMandate/auditMandatesList.tpl.html';
import './Main/auditMandate/GOVHistoryCtxtDirective-auditMandate.tpl.html';
import './Main/BCM/addBCMResponsibility.modal.tpl.html';
import './Main/BCM/biaBreadcrumbs.tpl.html';
import './Main/BCM/biaBUOwnerEdit.tpl.html';
import './Main/BCM/biaBUOwnerEditAddBIAResponsibilities.modal.tpl.html';
import './Main/BCM/biaProfileAdd.tpl.html';
import './Main/BCM/biaProfileEdit.tpl.html';
import './Main/BCM/biaProfileEditValidation.coordinator.modal.tpl.html';
import './Main/BCM/biaProfileIntroduction.coordinator.tpl.html';
import './Main/BCM/biaProfileIntroduction.modal.tpl.html';
import './Main/BCM/biaProfileSummary.tpl.html';
import './Main/BCM/biaResponsibilityEdit.tpl.html';
import './Main/BCM/biaResponsibilityEditForBUOwner.tpl.html';
import './Main/BCM/editBCMResponsibility.modal.tpl.html';
import './Main/BCM/editBIAResponsibility.modal.tpl.html';
import './Main/BCM/editBIAResponsibilityRatings.modal.tpl.html';
import './Main/BCM/GOVHistoryCtxtDirective-biaBUOwnerEdit.tpl.html';
import './Main/BCM/GOVHistoryCtxtDirective-biaProfileEdit.tpl.html';
import './Main/businessPlan/explorer/businessPlan.tpl.html';
import './Main/businessPlan/explorer/planDeliverablesByInitiative.tpl.html';
import './Main/businessPlan/explorer/planInitiatives.tpl.html';
import './Main/businessPlan/explorer/planSummary.tpl.html';
import './Main/cacm/cacm.tpl.html';
import './Main/cacm/cacmExportWarning.modal.tpl.html';
import './Main/cacm/events/cacmEventEdit.tpl.html';
import './Main/grcEdit/actionPlan/actionPlanEdit.tpl.html';
import './Main/grcEdit/actionPlanCriteria/actionPlanCriteriaEdit.tpl.html';
import './Main/grcEdit/businessPlan/initiative/deliverableEdit.tpl.html';
import './Main/grcEdit/businessPlan/initiative/deliverables.tpl.html';
import './Main/grcEdit/businessPlan/initiative/InitiativeAdd.tpl.html';
import './Main/grcEdit/businessPlan/initiative/initiativeBreadcrumbs.tpl.html';
import './Main/grcEdit/businessPlan/initiative/initiativeEdit.tpl.html';
import './Main/grcEdit/committee/CommitteeAdd.tpl.html';
import './Main/grcEdit/committee/CommitteeEdit.tpl.html';
import './Main/grcEdit/committee/committeeNotExists.tpl.html';
import './Main/grcEdit/committee/GOVHistoryCtxtDirective-committee.tpl.html';
import './Main/grcEdit/control/controlAdd.tpl.html';
import './Main/grcEdit/control/controlAssessment.tpl.html';
import './Main/grcEdit/control/controlEdit.tpl.html';
import './Main/grcEdit/control/controlHistory.tpl.html';
import './Main/grcEdit/control/controlNotExists.tpl.html';
import './Main/grcEdit/control/controlObservationList.tpl.html';
import './Main/grcEdit/control/controlReview.tpl.html';
import './Main/grcEdit/control/controlTest.tpl.html';
import './Main/grcEdit/control/controlTestList.tpl.html';
import './Main/grcEdit/control/controlTestObservationList.tpl.html';
import './Main/grcEdit/control/GOVHistoryCtxtDirective-control.tpl.html';
import './Main/grcEdit/control/relatedRisks.tpl.html';
import './Main/grcEdit/control/testResult.tpl.html';
import './Main/grcEdit/corporateRole/CorporateRoleAdd.tpl.html';
import './Main/grcEdit/corporateRole/CorporateRoleEdit.tpl.html';
import './Main/grcEdit/corporateRole/corporateRoleNotExists.tpl.html';
import './Main/grcEdit/corporateRole/GOVHistoryCtxtDirective-corporateRole.tpl.html';
import './Main/grcEdit/glossaryTerm/GlossaryTermAdd.tpl.html';
import './Main/grcEdit/glossaryTerm/GlossaryTermEdit.tpl.html';
import './Main/grcEdit/glossaryTerm/glossaryTermNotExists.tpl.html';
import './Main/grcEdit/glossaryTerm/GOVHistoryCtxtDirective-glossaryTerm.tpl.html';
import './Main/grcEdit/observation/GOVHistoryCtxtDirective-observation.tpl.html';
import './Main/grcEdit/observation/observationBreadcrumbs.tpl.html';
import './Main/grcEdit/observation/observationEdit.tpl.html';
import './Main/grcEdit/observation/observationRecommendationAdd.tpl.html';
import './Main/grcEdit/recommendation/GOVHistoryCtxtDirective-recommendation.tpl.html';
import './Main/grcEdit/recommendation/recommendationBreadcrumbs.tpl.html';
import './Main/grcEdit/recommendation/recommendationEdit.tpl.html';
import './Main/grcEdit/risk/GOVHistoryCtxtDirective-riskEdit.tpl.html';
import './Main/grcEdit/risk/riskEdit.tpl.html';
import './Main/grcEdit/risk/riskNotExists.tpl.html';
import './Main/grcEdit/risk/riskRelatedControls.tpl.html';
import './Main/grcEdit/risk/riskRelatedRiskEvents.tpl.html';
import './Main/grcEdit/risk/riskSubRisks.tpl.html';
import './Main/grcEdit/risk/viewHistoryOnRisk.tpl.html';
import './Main/grcEdit/riskEvent/GOVHistoryCtxtDirective-riskEventRelatedRisks.tpl.html';
import './Main/grcEdit/riskEvent/relatedRisks.tpl.html';
import './Main/grcEdit/riskEvent/riskEventEdit.tpl.html';
import './Main/grcEdit/riskEvent/riskEventNotExists.tpl.html';
import './Main/home/dashboard/actionPlanUpdateStatus.tpl.html';
import './Main/home/dashboard/aric.tpl.html';
import './Main/home/dashboard/auditMandates.tpl.html';
import './Main/home/dashboard/businessPlanning.tpl.html';
import './Main/home/dashboard/cacmEvents.tpl.html';
import './Main/home/dashboard/dashboard.tpl.html';
import './Main/home/dashboard/initiativeManagement.tpl.html';
import './Main/home/dashboard/initiativeUpdateStatus.tpl.html';
import './Main/home/dashboard/ItemsSummary.tpl.html';
import './Main/home/dashboard/ODDBusinessUnits.tpl.html';
import './Main/home/dashboard/riskSelfAssessment.tpl.html';
import './Main/home/dashboard/surveys.tpl.html';
import './Main/home/GOVHistoryCtxtDirective-searchResults.tpl.html';
import './Main/home/home.tpl.html';
import './Main/home/homeWithSolr.tpl.html';
import './Main/home/myTasks/actionPlanStatusUpdate.tpl.html';
import './Main/home/myTasks/biaProfileManagement.tpl.html';
import './Main/home/myTasks/controlCertification.tpl.html';
import './Main/home/myTasks/initiativeCreationEdit.tpl.html';
import './Main/home/myTasks/initiativeUpdateStatusAssessment.tpl.html';
import './Main/home/myTasks/myTasks.tpl.html';
import './Main/home/myTasks/pendingReviewRiskSelfAssessment.tpl.html';
import './Main/home/myTasks/riskSelfAssessment.tpl.html';
import './Main/initiativeUpdateStatus/assess/assessNoActiveProcess.tpl.html';
import './Main/initiativeUpdateStatus/assess/byInitiativeAssessment.tpl.html';
import './Main/initiativeUpdateStatus/assess/byInitiativeNoDeliverables.tpl.html';
import './Main/initiativeUpdateStatus/assess/completed.tpl.html';
import './Main/initiativeUpdateStatus/assess/deliverablesByQuarter.tpl.html';
import './Main/initiativeUpdateStatus/assess/deliverablesListByQuarter.tpl.html';
import './Main/initiativeUpdateStatus/assess/initiativeAssessmentAssess.tpl.html';
import './Main/initiativeUpdateStatus/assess/planDeliverableAssessment.tpl.html';
import './Main/initiativeUpdateStatus/assess/planInitiative.tpl.html';
import './Main/initiativeUpdateStatus/assess/welcome.tpl.html';
import './Main/initiativeUpdateStatus/eligibleForAssessment.tpl.html';
import './Main/initiativeUpdateStatus/GOVHistoryCtxtDirective-owner.tpl.html';
import './Main/initiativeUpdateStatus/initiativeUpdateStatus.tpl.html';
import './Main/initiativeUpdateStatus/ownerCard.tpl.html';
import './Main/initiativeUpdateStatus/ownersList.tpl.html';
import './Main/initiativeUpdateStatus/ownerWithInitiatives.tpl.html';
import './Main/initiativeUpdateStatus/review/backToDashboard.tpl.html';
import './Main/initiativeUpdateStatus/review/byInitiativeNoDeliverables.tpl.html';
import './Main/initiativeUpdateStatus/review/deliverablesByQuarter.tpl.html';
import './Main/initiativeUpdateStatus/review/deliverablesListByQuarter.tpl.html';
import './Main/initiativeUpdateStatus/review/initiativeAssessmentReview.tpl.html';
import './Main/initiativeUpdateStatus/review/noActiveProcess.tpl.html';
import './Main/initiativeUpdateStatus/review/planDeliverableReview.tpl.html';
import './Main/initiativeUpdateStatus/review/planInitiative.tpl.html';
import './Main/initiativeUpdateStatus/review/reviewInitiativeAssessmentByInitiative.tpl.html';
import './Main/initiativeUpdateStatus/withNoActiveProcess.tpl.html';
import './Main/navigation/navigation.tpl.html';
import './Main/navigation/navigationSolr.html';
import './Main/odd/businessUnits.tpl.html';
import './Main/odd/campaignStatusMgmt/externalParties.tpl.html';
import './Main/odd/externalPartyEdit/campaignEdit.tpl.html';
import './Main/odd/externalPartyEdit/campaignInviteDetailsEdit.tpl.html';
import './Main/odd/externalPartyEdit/campaignObservationListEdit.tpl.html';
import './Main/odd/externalPartyEdit/campaignQuestionnaireAddModal.tpl.html';
import './Main/odd/externalPartyEdit/campaignQuestionnaireEdit.tpl.html';
import './Main/odd/externalPartyEdit/campaignQuestionnaireListEdit.tpl.html';
import './Main/odd/externalPartyEdit/campaignQuestionnaireSectionAddModal.tpl.html';
import './Main/odd/externalPartyEdit/campaignQuestionnaireSectionListEdit.tpl.html';
import './Main/odd/externalPartyEdit/externalPartyAdd.tpl.html';
import './Main/odd/externalPartyEdit/externalPartyEdit.tpl.html';
import './Main/odd/questionnaireTemplatesEdit/questionnaireTemplateComponentListEdit.tpl.html';
import './Main/odd/questionnaireTemplatesEdit/questionnaireTemplateEdit.tpl.html';
import './Main/odd/questionnaireTemplatesEdit/questionnaireTemplateQuestionEdit.tpl.html';
import './Main/odd/questionnaireTemplatesEdit/questionnaireTemplateSectionEdit.tpl.html';
import './Main/odd/questionnaireTemplatesEdit/questionnaireTemplateSectionListEdit.tpl.html';
import './Main/odd/questionnaireTemplatesEdit/questionnaireTemplatesList.tpl.html';
import './Main/odd/questionnaireTemplatesEdit/questionnaireTemplateStaticTextEdit.tpl.html';
import './Main/odd/surveyCampaigns/campaignRespondentList.tpl.html';
import './Main/odd/surveyCampaigns/oddExternalRespondentModal.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignAdd.tpl.html';
import './Main/odd/surveyCampaigns/SurveyCampaignComponentListEdit.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignEdit.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignInviteDetailsEdit.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignList.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignQuestionEdit.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignQuestionnaireEdit.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignQuestionnaireListEdit.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignQuestionnaireSectionEdit.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignQuestionnaireStaticTextEdit.tpl.html';
import './Main/odd/surveyCampaigns/surveyCampaignSectionListEdit.tpl.html';
import './Main/procedure/ProcedureEditAccessRights.tpl.html';
import './Main/procedure/procedureEditMetadata.tpl.html';
import './Main/procedure/ProcedureEditReviewers.tpl.html';
import './Main/procedure/procedureMetadataContent.tpl.html';
import './Main/procedure/procedureMetadataReview.modal.tpl.html';
import './Main/procedure/procedureResponsibilityEdit.tpl.html';
import './Main/procedure/procedureSectionList.tpl.html';
import './Main/procedure/procedureSectionListEdit.tpl.html';
import './Main/procedure/responsibility/procedureResponsibilityEdit.tpl.html';
import './Main/procedure/sectionBlock/procedureSectionBlockEdit.tpl.html';
import './Main/procedure/sectionBlock/procedureSectionBlockView.tpl.html';
import './Main/procedure/sectionBlock/procedureSectionDiffReview.tpl.html';
import './Main/procedure/sectionBlock/procedureSectionReview.modal.tpl.html';
import './Main/recom/governanceProcessEdit.tpl.html';
import './Main/recom/governanceProcessList.tpl.html';
import './Main/recomActionPlanStatusUpdate/actionPlanUpdateStatus.tpl.html';
import './Main/recomActionPlanStatusUpdate/actionPlanUpdateStatusValidateModal.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/actionPlan.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/actionPlanAssessment.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/actionPlanSelector.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/assessNoActiveProcess.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/byActionPlan.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/byActionPlanCriterias.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/byActionPlanNoCriterias.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/byQuarter.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/completed.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/criteriaAssessment.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/criteriasListByActionPlan.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/criteriasListByQuarter.tpl.html';
import './Main/recomActionPlanStatusUpdate/assess/welcome.tpl.html';
import './Main/recomActionPlanStatusUpdate/govProcEditModal.tpl.html';
import './Main/recomActionPlanStatusUpdate/ownerCard.tpl.html';
import './Main/recomActionPlanStatusUpdate/ownerList.tpl.html';
import './Main/recomActionPlanStatusUpdate/ownerSendReminderModal.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/actionPlan.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/actionPlanAssessment.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/actionPlanSelector.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/backToDashboard.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/byActionPlan.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/byActionPlanAssessment.editCommentActionPlanAssessment.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/byActionPlanAssessment.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/byActionPlanCriterias.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/byActionPlanNoCriterias.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/byQuarter.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/criteriaReview.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/criteriasListByActionPlan.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/criteriasListByQuarter.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/GOVHistoryCtxtDirective-recomStatusUpdate.tpl.html';
import './Main/recomActionPlanStatusUpdate/review/noActiveProcess.tpl.html';
import './Main/recomActionPlanStatusUpdate/SelectAssessment.tpl.html';
import './Main/recomActionPlanStatusUpdate/welcome.tpl.html';
import './Main/recomActionPlanStatusUpdate/withNoActiveProcess.tpl.html';
import './Main/riskSelfAssessment/assess/assess.tpl.html';
import './Main/riskSelfAssessment/assess/assessFinalQuestions.tpl.html';
import './Main/riskSelfAssessment/assess/assessNoActiveProcess.tpl.html';
import './Main/riskSelfAssessment/assess/assessNoRisksToAssess.tpl.html';
import './Main/riskSelfAssessment/assess/assessPreliminaryQuestions.tpl.html';
import './Main/riskSelfAssessment/assess/assessRisk.tpl.html';
import './Main/riskSelfAssessment/assess/assessRiskAcknowledgement.tpl.html';
import './Main/riskSelfAssessment/assess/assessRiskActions.tpl.html';
import './Main/riskSelfAssessment/assess/assessRiskClosing.tpl.html';
import './Main/riskSelfAssessment/assess/assessRiskComments.tpl.html';
import './Main/riskSelfAssessment/assess/assessRiskEvents.tpl.html';
import './Main/riskSelfAssessment/assess/assessRiskNameAndDescriptionChanges.tpl.html';
import './Main/riskSelfAssessment/assess/assessRiskRatings.tpl.html';
import './Main/riskSelfAssessment/assess/assessRiskRatingsOverall.tpl.html';
import './Main/riskSelfAssessment/assess/assessRiskRecommendClosing.tpl.html';
import './Main/riskSelfAssessment/assess/assessSummary.tpl.html';
import './Main/riskSelfAssessment/assess/assessSummaryActions.tpl.html';
import './Main/riskSelfAssessment/assess/assessSummaryRiskItem.tpl.html';
import './Main/riskSelfAssessment/assess/assessWelcome.tpl.html';
import './Main/riskSelfAssessment/assess/GOVHistoryCtxtDirective-riskSelfAssessmentSummary.tpl.html';
import './Main/riskSelfAssessment/list/rcsaStatusAssessorCard.tpl.html';
import './Main/riskSelfAssessment/list/rcsaStatusAssessorCardModal.tpl.html';
import './Main/riskSelfAssessment/list/riskSelfAssessmentList.tpl.html';
import './Main/riskSelfAssessment/review/changeKeyRiskRatingsModal.tpl.html';
import './Main/riskSelfAssessment/review/changeMitigationRating.tpl.html';
import './Main/riskSelfAssessment/review/changeOverallRating.tpl.html';
import './Main/riskSelfAssessment/review/changeProbabilityRating.tpl.html';
import './Main/riskSelfAssessment/review/changeSeverityRating.tpl.html';
import './Main/riskSelfAssessment/review/finalChangesConfirmationModal.tpl.html';
import './Main/riskSelfAssessment/review/finalRatings.Key.tpl.html';
import './Main/riskSelfAssessment/review/finalRatings.Top.tpl.html';
import './Main/riskSelfAssessment/review/GOVHistoryCtxtDirective-riskSelfAssessmentReviewSummary.tpl.html';
import './Main/riskSelfAssessment/review/keyRiskToReview.tpl.html';
import './Main/riskSelfAssessment/review/preFinalRatings.Key.tpl.html';
import './Main/riskSelfAssessment/review/preFinalRatings.Top.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessor.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorRisk.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorRiskAcknowledgement.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorRiskActions.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorRiskClosing.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorRiskComments.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorRiskIsAccurate.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorRiskNameAndDescriptionChanges.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorRiskRecommendClosing.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorSummary.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorSummaryActions.tpl.html';
import './Main/riskSelfAssessment/review/reviewByAssessorSummaryRiskItem.tpl.html';
import './Main/riskSelfAssessment/review/reviewFinalQuestions.tpl.html';
import './Main/riskSelfAssessment/review/reviewPreliminaryQuestions.tpl.html';
import './Main/riskSelfAssessment/review/reviewRisk.tpl.html';
import './Main/riskSelfAssessment/review/reviewRiskActions.tpl.html';
import './Main/riskSelfAssessment/review/reviewRiskChangeMitigationRatings.tpl.html';
import './Main/riskSelfAssessment/review/reviewRiskChangeOverallRatings.tpl.html';
import './Main/riskSelfAssessment/review/reviewRiskChangeProbabilityRatings.tpl.html';
import './Main/riskSelfAssessment/review/reviewRiskChangeSeverityRatings.tpl.html';
import './Main/riskSelfAssessment/review/reviewRiskEvents.tpl.html';
import './Main/riskSelfAssessment/review/reviewRiskRatings.tpl.html';
import './Main/riskSelfAssessment/review/reviewRiskRatingsOverall.tpl.html';
import './Main/riskSelfAssessment/review/reviewTopRiskList.tpl.html';
import './Main/riskSelfAssessment/review/topRiskToReview.tpl.html';
import './Main/search/GOVHistoryCtxtDirective-searchResults.tpl.html';
import './Main/search/search.tpl.html';
import './Main/signalr/chat.tpl.html';
import './Main/staticHtmlPage/Main.tpl.html';
import './Main/survey/availableSurveys.tpl.html';
import './Main/survey/campaign/campaign.tpl.html';
import './Main/survey/campaign/campaignGeneral.tpl.html';
import './Main/survey/campaign/campaignInvitationEmail.tpl.html';
import './Main/survey/campaign/campaignInvitationEmailEN.tpl.html';
import './Main/survey/campaign/campaignInvitationEmailFR.tpl.html';
import './Main/survey/campaign/campaignList.tpl.html';
import './Main/survey/campaign/campaignPartAddQuestion.tpl.html';
import './Main/survey/campaign/campaignPartBuilder.tpl.html';
import './Main/survey/campaign/campaignPartCard.tpl.html';
import './Main/survey/campaign/campaignParts.tpl.html';
import './Main/survey/campaign/campaignQuestion-FreeText-Default.tpl.html';
import './Main/survey/campaign/campaignQuestion-FreeText-Optional.tpl.html';
import './Main/survey/campaign/campaignQuestion-MultipleChoice-EconomicsExpertiseTitle.tpl.html';
import './Main/survey/campaign/campaignQuestion-MultipleChoice-EconomicsExpertiseWithoutTitle.tpl.html';
import './Main/survey/campaign/campaignQuestion-MultipleChoice-Horizontal.tpl.html';
import './Main/survey/campaign/campaignQuestion-MultipleChoice-QuizWithOneResponse.tpl.html';
import './Main/survey/campaign/campaignQuestion-MultipleChoice-RatingWithoutTitle.tpl.html';
import './Main/survey/campaign/campaignQuestion-MultipleChoice-RatingWithTitle.tpl.html';
import './Main/survey/campaign/campaignQuestion-MultipleChoice-Toggle.tpl.html';
import './Main/survey/campaign/campaignQuestion-MultipleChoice-Vertical.tpl.html';
import './Main/survey/campaign/campaignQuestion-Ranking-WithoutTitle.tpl.html';
import './Main/survey/campaign/campaignQuestion-Ranking-WithTitle.tpl.html';
import './Main/survey/campaign/campaignQuestionCard.tpl.html';
import './Main/survey/campaign/campaignQuestionEditing.tpl.html';
import './Main/survey/campaign/campaignRespondentCard.tpl.html';
import './Main/survey/campaign/campaignSettings.tpl.html';
import './Main/survey/campaign/campaignVisualComponentCard.tpl.html';
import './Main/survey/campaign/newCampaign.tpl.html';
import './Main/survey/campaign/owner/campaignOwnerCard.tpl.html';
import './Main/survey/campaign/owner/campaignOwnersList.tpl.html';
import './Main/survey/campaign/owner/selectNewOwnerModal.tpl.html';
import './Main/survey/campaign/selectNewRespondentModal.tpl.html';
import './Main/survey/campaign/sidebarCampaign.tpl.html';
import './Main/survey/campaign/sidebarCampaignList.tpl.html';
import './Main/survey/campaign/sidebarCampaignPartBuilder.tpl.html';
import './Main/survey/campaign/sidebarNewCampaign.tpl.html';
import './Main/survey/completed.tpl.html';
import './Main/survey/sidebarSurveyRespondent.tpl.html';
import './Main/survey/survey.tpl.html';
import './Main/survey/surveyNotAvailable.tpl.html';
import './Main/survey/surveyQuestion-FreeText-Default.tpl.html';
import './Main/survey/surveyQuestion-FreeText-Optional.tpl.html';
import './Main/survey/surveyQuestion-MultipleChoice-EconomicsExpertiseTitle.tpl.html';
import './Main/survey/surveyQuestion-MultipleChoice-EconomicsExpertiseWithoutTitle.tpl.html';
import './Main/survey/surveyQuestion-MultipleChoice-Horizontal.tpl.html';
import './Main/survey/surveyQuestion-MultipleChoice-QuizWithOneResponse.tpl.html';
import './Main/survey/surveyQuestion-MultipleChoice-RatingWithoutTitle.tpl.html';
import './Main/survey/surveyQuestion-MultipleChoice-RatingWithTitle.tpl.html';
import './Main/survey/surveyQuestion-MultipleChoice-Toggle.tpl.html';
import './Main/survey/surveyQuestion-MultipleChoice-Vertical.tpl.html';
import './Main/survey/surveyQuestion-Ranking-WithoutTitle.tpl.html';
import './Main/survey/surveyQuestion-Ranking-WithTitle.tpl.html';
import './Main/survey/surveyRespondentPage.tpl.html';
import './Main/survey/welcome.tpl.html';
import './Main/visualGuidelines/component/component.confirmClick.tpl.html';
import './Main/visualGuidelines/component/component.displayPerson.tpl.html';
import './Main/visualGuidelines/component/component.fallbackSrc.tpl.html';
import './Main/visualGuidelines/component/component.govContact.tpl.html';
import './Main/visualGuidelines/component/component.home.tpl.html';
import './Main/visualGuidelines/component/component.pickerDepartmentRisk.tpl.html';
import './Main/visualGuidelines/component/component.pickerPerson.tpl.html';
import './Main/visualGuidelines/component/component.tpl.html';
import './Main/visualGuidelines/style/style.color.tpl.html';
import './Main/visualGuidelines/style/style.home.tpl.html';
import './Main/visualGuidelines/style/style.icons.tpl.html';
import './Main/visualGuidelines/style/style.tpl.html';
import './Main/visualGuidelines/style/style.typography.tpl.html';
import './Main/visualGuidelines/visualGuidelines.tpl.html';
import './shared/auditMandate/auditMandate.full.tpl.html';
import './shared/auditMandate/auditMandate.nav-search.item.tpl.html';
import './shared/auditMandate/auditMandate.nav-solr.item.tpl.html';
import './shared/BCM/BCMResponsibility/bcmResponsibility.full.modalContent.tpl.html';
import './shared/BCM/BCMResponsibility/bcmResponsibility.modal.item.tpl.html';
import './shared/BCM/BCMResponsibility/bcmResponsibility.modal.toAdd.tpl.html';
import './shared/BCM/BIABUOwner/biaBuOwner.addBIAResponsibilities.modalContent.tpl.html';
import './shared/BCM/BIABUOwner/biaBuOwner.bia-summary.tpl.html';
import './shared/BCM/BIABUOwner/biaBuOwner.editPart.item.tpl.html';
import './shared/BCM/BIABUOwner/biaBuOwner.full.tpl.html';
import './shared/BCM/BIABUOwner/biaBuOwner.item.tpl.html';
import './shared/BCM/BIABUOwner/biaBuOwner.modal.item.tpl.html';
import './shared/BCM/BIABUOwner/biaBuOwner.nav.ctxt.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.full_businessUnits.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.full_coordinatorsEdit.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.full_name.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.full.coordinators.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.full.create.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.full.name.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.full.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.nav-search.item.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.nav-solr.item.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.nav.ctxt.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.nav.item.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.summary.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.summary.criticalityView.tpl.html';
import './shared/BCM/BIAProfile/biaProfileBUOwnerValidation.reject.modal.tpl.html';
import './shared/BCM/BIAProfile/biaProfileBUOwnerValidation.validate.modal.tpl.html';
import './shared/BCM/BIAProfile/biaProfileFollowUp.list.tpl.html';
import './shared/BCM/BIAResponsibility/biaKeyPersonDirective.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.banner.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.editName.modalContent.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.editPart.item.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.editRatings.modalContent.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.editSpecialNeeds.modalContent.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.recoveryMetrics.edit.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.resourceRequirements.edit.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.dependency.edit.tpl.html';
import './shared/BCM/BIAProfile/bcmBiaProfile.activityProcess.modal.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.full_executionPlanEdit.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.full.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.item.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.keyStaff.edit.modal.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.keyStaff.modal.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.KeySystems.modal.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.list.modal.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.list.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.modal.item.tpl.html';
import './shared/BCM/BIAResponsibility/biaResponsibility.responsibilitiesToBeRated.modal.tpl.html';
import './shared/boxTemplate/boxConfirmWhenDirtyPage.tpl.html';
import './shared/businessUnit/businessUnit.modal.item.tpl.html';
import './shared/businessUnit/businessUnit.nav-search.item.tpl.html';
import './shared/businessUnit/businessUnit.nav-solr.item.tpl.html';
import './shared/cacm/concurExpense/cacmConcurExpense.nav.item.tpl.html';
import './shared/cacm/control/cacmControl.nav.item.tpl.html';
import './shared/cacm/control/cacmControl.nav.itemToIndex.tpl.html';
import './shared/cacm/datapoint/cacmDataPoint.list.item.tpl.html';
import './shared/cacm/dynamicsAccountTransaction/cacmDynamicsAccountTransaction.nav.item.tpl.html';
import './shared/cacm/event/cacmEvent.full.tpl.html';
import './shared/cacm/event/cacmEvent.list.small.tpl.html';
import './shared/cacm/event/cacmEvent.list.tpl.html';
import './shared/cacm/event/cacmEvent.nav.item.tpl.html';
import './shared/cacm/event/cacmEvent.nav.itemToIndex.tpl.html';
import './shared/cacm/event/cacmEvent.nav.list.tpl.html';
import './shared/cacm/event/FindCACMEventGroup.tpl.html';
import './shared/cacm/followup/cacmFollowUp.full.tpl.html';
import './shared/cacm/followup/cacmFollowUp.list.tpl.html';
import './shared/committee/committee.full.tpl.html';
import './shared/committee/committee.nav-search.item.tpl.html';
import './shared/committee/committee.nav-solr.item.tpl.html';
import './shared/components/controllers/retryAuthenticationModal.tpl.html';
import './shared/components/directives/confirmClick.tpl.html';
import './shared/components/directives/editInPlace-text.tpl.html';
import './shared/components/directives/editInPlace-textarea.tpl.html';
import './shared/components/directives/editInPlace.tpl.html';
import './shared/components/directives/govBreadcrumb.tpl.html';
import './shared/components/directives/govClosedTag.tpl.html';
import './shared/components/directives/govColoredTooltip.tpl.html';
import './shared/components/directives/govPager.directive.html';
import './shared/components/directives/govPager.directive.small.html';
import './shared/components/directives/highlightOverlay.tpl.html';
import './shared/components/directives/scrollTop.tpl.html';
import './shared/components/directives/sidebarHelper.tpl.html';
import './shared/components/directives/textareaRead.tpl.html';
import './shared/components/directives/topBar.tpl.html';
import './shared/components/services/modalForm.tpl.html';
import './shared/components/services/modalWithTemplate.tpl.html';
import './shared/components/services/pageDirtyDialog.tpl.html';
import './shared/corporateRole/corporateRole.full.tpl.html';
import './shared/corporateRole/corporateRole.nav-search.item.tpl.html';
import './shared/corporateRole/corporateRole.nav-solr.item.tpl.html';
import './shared/followUp/assessmentFollowUpsModal.tpl.html';
import './shared/followUp/followUp.full.tpl.html';
import './shared/followUp/followUp.list.tpl.html';
import './shared/followUp/followUp.nav.action.tpl.html';
import './shared/followUp/recommendationFollowUpsModal.tpl.html';
import './shared/glossaryTerm/glossaryTerm.full.tpl.html';
import './shared/glossaryTerm/glossaryTerm.nav-search.item.tpl.html';
import './shared/glossaryTerm/glossaryTerm.nav-solr.item.tpl.html';
import './shared/grc/actionPlan/grcActionPlan.full.tpl.html';
import './shared/grc/actionPlan/grcActionPlan.list-with-deliverables.tpl.html';
import './shared/grc/actionPlan/grcActionPlan.list.tpl.html';
import './shared/grc/actionPlan/grcActionPlan.nav-search.item.tpl.html';
import './shared/grc/actionPlan/grcActionPlan.nav-solr.item.tpl.html';
import './shared/grc/actionPlan/grcActionPlan.nav.action.tpl.html';
import './shared/grc/actionPlan/grcActionPlan.nav.item-with-deliverables.tpl.html';
import './shared/grc/actionPlan/grcActionPlan.nav.item.tpl.html';
import './shared/grc/actionPlan/grcActionPlanComments.modal.tpl.html';
import './shared/grc/actionPlan/grcActionPlanEdit.name.modal.tpl.html';
import './shared/grc/actionPlanCriteria/actionPlanCriteria.tpl.html';
import './shared/grc/actionPlanCriteria/assessmentFollowUpsModal.tpl.html';
import './shared/grc/actionPlanCriteria/grcActionPlanCriteria.full.tpl.html';
import './shared/grc/actionPlanCriteria/grcActionPlanCriteria.list.tpl.html';
import './shared/grc/actionPlanCriteria/grcActionPlanCriteria.nav.action.tpl.html';
import './shared/grc/actionPlanCriteria/grcActionPlanCriteria.nav.item.tpl.html';
import './shared/grc/actionPlanCriteria/grcActionPlanCriteriaEdit.modal.tpl.html';
import './shared/grc/businessPlanning/assessment/assessmentFollowUpsModal.tpl.html';
import './shared/grc/businessPlanning/deliverable/grcPlanDeliverable.explorer.item.tpl.html';
import './shared/grc/businessPlanning/deliverable/grcPlanDeliverable.full.edit.tpl.html';
import './shared/grc/businessPlanning/deliverable/grcPlanDeliverable.list.tpl.html';
import './shared/grc/businessPlanning/deliverable/grcPlanDeliverable.nav.action.tpl.html';
import './shared/grc/businessPlanning/deliverable/grcPlanDeliverable.nav.item.tpl.html';
import './shared/grc/businessPlanning/initiative/govProcEditModal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiative.add.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiative.assessment.selector.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiative.assessmentReview.selector.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiative.explorer.item.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiative.full.view.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiative.nav-search.item.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiative.nav-solr.item.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiative.nav.item.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeDeleteAssessmentsConfirmModal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.budget.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.category.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.head-count.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.key-benefits.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.mitigated-risks.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.name.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.other.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.rationale.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.resources.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeEditModal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeRiskSelector.modal.tpl.html';
import './shared/grc/businessPlanning/initiative/grcPlanInitiativeViewDetails.risk.tpl.html';
import './shared/grc/control/controlCertification.tpl.html';
import './shared/grc/control/grcControl.full.tpl.html';
import './shared/grc/control/grcControl.list.tpl.html';
import './shared/grc/control/grcControl.listNew.tpl.html';
import './shared/grc/control/grcControl.modal.item.tpl.html';
import './shared/grc/control/grcControl.nav-search.item.tpl.html';
import './shared/grc/control/grcControl.nav-solr.item.tpl.html';
import './shared/grc/control/grcControl.nav.action.tpl.html';
import './shared/grc/control/grcControl.nav.ctxt.tpl.html';
import './shared/grc/control/grcControl.nav.item.tpl.html';
import './shared/grc/control/grcControl.nav.itemNew.tpl.html';
import './shared/grc/control/grcControlAssessment.full.ActionsFooter.tpl.html';
import './shared/grc/control/grcControlAssessment.full.FinalLastFYAuditResult.tpl.html';
import './shared/grc/control/grcControlAssessment.full.IsAntiFraudControl.tpl.html';
import './shared/grc/control/grcControlAssessment.full.IsKeyControl.tpl.html';
import './shared/grc/control/grcControlAssessment.full.LastFYAuditResult.tpl.html';
import './shared/grc/control/grcControlAssessment.full.MajorOperationalChanges.tpl.html';
import './shared/grc/control/grcControlAssessment.full.MustTestForExternal.tpl.html';
import './shared/grc/control/grcControlAssessment.full.RelatedRiskCoveredInRCSA.tpl.html';
import './shared/grc/control/grcControlAssessment.full.Selected.tpl.html';
import './shared/grc/control/grcControlAssessment.full.StatusFooter.tpl.html';
import './shared/grc/control/grcControlAssessment.full.TestedImplementationInPastTwoYears.tpl.html';
import './shared/grc/control/grcControlAssessment.full.TestedInPastTwoYears.tpl.html';
import './shared/grc/control/grcControlAssessment.full.TestedInSeparateMandate.tpl.html';
import './shared/grc/control/grcControlAssessment.full.tpl.html';
import './shared/grc/control/grcControlAssessment.list.history.tpl.html';
import './shared/grc/control/grcControlAssessment.nav.action.tpl.html';
import './shared/grc/control/grcControlAssessment.nav.item.tpl.html';
import './shared/grc/control/grcControlCertification.full.Comment.tpl.html';
import './shared/grc/control/grcControlCertification.full.Footer.tpl.html';
import './shared/grc/control/grcControlCertification.full.Header.tpl.html';
import './shared/grc/control/grcControlCertification.full.IsAccurate.tpl.html';
import './shared/grc/control/grcControlCertification.full.Performance.tpl.html';
import './shared/grc/control/grcControlCertification.full.review.Comment.tpl.html';
import './shared/grc/control/grcControlCertification.full.review.Footer.tpl.html';
import './shared/grc/control/grcControlCertification.full.review.IsAccurate.tpl.html';
import './shared/grc/control/grcControlCertification.full.review.Performance.tpl.html';
import './shared/grc/control/grcControlCertification.full.review.tpl.html';
import './shared/grc/control/grcControlCertification.full.tpl.html';
import './shared/grc/control/grcControlCertification.nav.item.tpl.html';
import './shared/grc/control/grcControlHistory.full.ControlAssessment.tpl.html';
import './shared/grc/control/grcControlHistory.full.ControlCertification.tpl.html';
import './shared/grc/control/grcControlHistory.full.tpl.html';
import './shared/grc/control/grcControlHistory.full.VersioningControl.tpl.html';
import './shared/grc/control/grcControlHistory.full.VersioningControlOwner.tpl.html';
import './shared/grc/control/grcControlHistory.nav.action.tpl.html';
import './shared/grc/control/grcControlReview.full.ActionsFooter.tpl.html';
import './shared/grc/control/grcControlReview.full.DesignEffectiveness.tpl.html';
import './shared/grc/control/grcControlReview.full.ImplementationEffectiveness.tpl.html';
import './shared/grc/control/grcControlReview.full.OperationalEffectiveness.tpl.html';
import './shared/grc/control/grcControlReview.full.ReviewedBy.tpl.html';
import './shared/grc/control/grcControlReview.full.StatusFooter.tpl.html';
import './shared/grc/control/grcControlReview.full.tpl.html';
import './shared/grc/control/grcControlReview.nav.action.tpl.html';
import './shared/grc/control/grcControlReview.nav.item.DesignEffectiveness.tpl.html';
import './shared/grc/control/grcControlReview.nav.item.ImplementationEffectiveness.tpl.html';
import './shared/grc/control/grcControlReview.nav.item.OperationalEffectiveness.tpl.html';
import './shared/grc/control/grcControlReview.nav.item.tpl.html';
import './shared/grc/control/grcControlTest.full.edit.tpl.html';
import './shared/grc/control/grcControlTest.list.tpl.html';
import './shared/grc/control/grcControlTest.nav.action.tpl.html';
import './shared/grc/control/grcControlTest.nav.item.tpl.html';
import './shared/grc/control/grcControlTestTestingInfos.tpl.html';
import './shared/grc/control/grcTestResult.full.edit.ToDoNext.tpl.html';
import './shared/grc/control/grcTestResult.full.edit.tpl.html';
import './shared/grc/control/grcTestResult.list.history.tpl.html';
import './shared/grc/control/grcTestResult.nav.action.tpl.html';
import './shared/grc/control/selectControlModal.tpl.html';
import './shared/grc/governanceProcess/grcGovernanceProcess.full.tpl.html';
import './shared/grc/governanceProcess/grcGovernanceProcess.list.tpl.html';
import './shared/grc/governanceProcess/grcGovernanceProcess.nav.item.tpl.html';
import './shared/grc/observation/grcObservation.full.tpl.html';
import './shared/grc/observation/grcObservation.list.tpl.html';
import './shared/grc/observation/grcObservation.nav.action.tpl.html';
import './shared/grc/observation/grcObservation.nav.ctxt.tpl.html';
import './shared/grc/observation/grcObservation.nav.item.tpl.html';
import './shared/grc/observation/grcObservation.nav.itemWithDetails.tpl.html';
import './shared/grc/pointsOfFocus/selectPointsOfFocusModal.tpl.html';
import './shared/grc/recommendation/grcRecommendation.full.create.tpl.html';
import './shared/grc/recommendation/grcRecommendation.full.tpl.html';
import './shared/grc/recommendation/grcRecommendation.list.tpl.html';
import './shared/grc/recommendation/grcRecommendation.listNew.tpl.html';
import './shared/grc/recommendation/grcRecommendation.nav-search.item.tpl.html';
import './shared/grc/recommendation/grcRecommendation.nav-solr.item.tpl.html';
import './shared/grc/recommendation/grcRecommendation.nav.action.tpl.html';
import './shared/grc/recommendation/grcRecommendation.nav.ctxt.tpl.html';
import './shared/grc/recommendation/grcRecommendation.nav.item.tpl.html';
import './shared/grc/recommendation/grcRecommendation.nav.list.tpl.html';
import './shared/grc/recommendation/grcRecommendation.nav.listNew.tpl.html';
import './shared/grc/recommendation/grcRecommendationEdit.name.modal.tpl.html';
import './shared/grc/recommendation/recommendationExport.tpl.html';
import './shared/grc/recommendation/selectRecommendationModal.tpl.html';
import './shared/grc/risk/assessmentRatings.tpl.html';
import './shared/grc/risk/departmentalRisksExport.tpl.html';
import './shared/grc/risk/departmentalRisksExportModal.tpl.html';
import './shared/grc/risk/grcRisk.full.tpl.html';
import './shared/grc/risk/grcRisk.list.tpl.html';
import './shared/grc/risk/grcRisk.list.withAssessment.tpl.html';
import './shared/grc/risk/grcRisk.nav-search.item.tpl.html';
import './shared/grc/risk/grcRisk.nav-solr.item.tpl.html';
import './shared/grc/risk/grcRisk.nav.action.tpl.html';
import './shared/grc/risk/grcRisk.nav.ctxt.tpl.html';
import './shared/grc/risk/grcRisk.nav.item.tpl.html';
import './shared/grc/risk/grcRisk.nav.rowitem.tpl.html';
import './shared/grc/risk/grcRisk.nav.subRisks.tpl.html';
import './shared/grc/risk/grcRiskHistory.full.RiskAssessment.tpl.html';
import './shared/grc/risk/grcRiskHistory.full.tpl.html';
import './shared/grc/risk/grcRiskHistory.full.VersioningParentRisk.tpl.html';
import './shared/grc/risk/grcRiskHistory.full.VersioningRisk.tpl.html';
import './shared/grc/risk/grcRiskHistory.full.VersioningRiskAssessor.tpl.html';
import './shared/grc/risk/grcRiskHistory.full.VersioningRiskType.tpl.html';
import './shared/grc/risk/grcRiskHistory.full.VersioningSubRisk.tpl.html';
import './shared/grc/risk/grcRiskHistory.nav.action.tpl.html';
import './shared/grc/risk/riskExportExcel.tpl.html';
import './shared/grc/risk/selectDepartmentRiskModal.tpl.html';
import './shared/grc/risk/selectGovernanceProcessesForExportExcel.tpl.html';
import './shared/grc/risk/showRiskAssessmentRatingsLegend.tpl.html';
import './shared/grc/riskEvent/grcRiskEvent.full.tpl.html';
import './shared/grc/riskEvent/grcRiskEvent.list.tpl.html';
import './shared/grc/riskEvent/grcRiskEvent.nav-search.item.tpl.html';
import './shared/grc/riskEvent/grcRiskEvent.nav-solr.item.tpl.html';
import './shared/grc/riskEvent/grcRiskEvent.nav.action.tpl.html';
import './shared/grc/riskEvent/grcRiskEvent.nav.ctxt.tpl.html';
import './shared/grc/riskEvent/grcRiskEvent.nav.item.tpl.html';
import './shared/iamSystem/iamSystem.editPart.item.tpl.html';
import './shared/iamSystem/iamSystem.list.tpl.html';
import './shared/iamSystem/iamSystem.modal.item.tpl.html';
import './shared/odd/campaign/oddCampaign.full.tpl.html';
import './shared/odd/campaign/oddCampaign.list.tpl.html';
import './shared/odd/campaign/oddCampaign.nav.item.tpl.html';
import './shared/odd/campaign/oddCampaign.summary.campaign.tpl.html';
import './shared/odd/campaign/oddCampaign.summary.survey.tpl.html';
import './shared/odd/campaign/oddCampaignInviteDetails.full.tpl.html';
import './shared/odd/campaign/oddCampaignInviteDetails.nav.item.tpl.html';
import './shared/odd/campaign/oddCampaignQuestionnaire.full.tpl.html';
import './shared/odd/campaign/oddCampaignQuestionnaire.list.edit.tpl.html';
import './shared/odd/campaign/oddCampaignQuestionnaire.list.tpl.html';
import './shared/odd/campaign/oddCampaignQuestionnaire.nav.edit.tpl.html';
import './shared/odd/campaign/oddCampaignQuestionnaire.nav.item.tpl.html';
import './shared/odd/campaign/oddCampaignQuestionnaireSection.list.edit.tpl.html';
import './shared/odd/campaign/oddCampaignQuestionnaireSection.list.tpl.html';
import './shared/odd/campaign/oddCampaignQuestionnaireSection.nav.edit.tpl.html';
import './shared/odd/campaign/oddCampaignQuestionnaireSection.nav.item.tpl.html';
import './shared/odd/campaign/oddCampaignSurveyInviteDetails.full.tpl.html';
import './shared/odd/campaign/oddCampaignSurveyInviteDetails.nav.item.tpl.html';
import './shared/odd/campaign/summarySurveyExportReportsModal.tpl.html';
import './shared/odd/campaignRespondent/oddCampaignRespondent.list.tpl.html';
import './shared/odd/campaignRespondent/oddCampaignRespondent.nav.item.tpl.html';
import './shared/odd/externalParty/oddExternalParty.full.tpl.html';
import './shared/odd/externalParty/oddExternalParty.nav.item.tpl.html';
import './shared/odd/oddPublic/followUpModal.tpl.html';
import './shared/odd/oddPublic/oddComponent.Attachment.Default.tpl.html';
import './shared/odd/oddPublic/oddComponent.Date.Default.tpl.html';
import './shared/odd/oddPublic/oddComponent.FreeText.Default.tpl.html';
import './shared/odd/oddPublic/oddComponent.MultipleChoice.Default.tpl.html';
import './shared/odd/oddPublic/oddComponent.MultipleChoiceMultipleLabels.Horizontal.tpl.html';
import './shared/odd/oddPublic/oddComponent.MultipleChoiceMultipleLabels.Vertical.tpl.html';
import './shared/odd/oddPublic/oddComponent.MultipleFields.Default.tpl.html';
import './shared/odd/oddPublic/oddComponent.Numerical.Default.tpl.html';
import './shared/odd/oddPublic/oddComponent.Percentage.Default.tpl.html';
import './shared/odd/oddPublic/oddComponent.Ranking.Default.tpl.html';
import './shared/odd/oddPublic/oddComponent.StaticText.Default.tpl.html';
import './shared/odd/oddPublic/oddComponentPreview.full.tpl.html';
import './shared/odd/oddPublic/oddField.Attachment.Default.tpl.html';
import './shared/odd/oddPublic/oddField.Date.Default.tpl.html';
import './shared/odd/oddPublic/oddField.MultilineText.Default.tpl.html';
import './shared/odd/oddPublic/oddField.MultipleChoice.Default.tpl.html';
import './shared/odd/oddPublic/oddField.Text.Default.tpl.html';
import './shared/odd/oddPublic/questionAttachment.tpl.html';
import './shared/odd/questionnaireTemplate/oddConditionableSection.modal.tpl.html';
import './shared/odd/questionnaireTemplate/oddConditionableSection.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplate.full.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplate.list.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplate.nav.item.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateComponent.list.edit.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateComponent.list.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplatePageBreak.nav.edit.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplatePageBreak.nav.item.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateQuestion.nav.edit.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateQuestion.nav.item.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateQuestionChoice.nav.item.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateSection.full.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateSection.list.edit.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateSection.list.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateSection.nav.action.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateSection.nav.edit.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateSection.nav.item.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateStaticText.full.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateStaticText.nav.edit.tpl.html';
import './shared/odd/questionnaireTemplate/oddQuestionnaireTemplateStaticText.nav.item.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddConditionableQuestion.modal.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddConditionableQuestion.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionAttachments.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionComponentFields.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionMultipleChoices.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionMultipleLabels.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.Attachment.Default.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.Date.Default.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.FreeText.Default.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.modal.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.MultipleChoice.Default.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.MultipleChoiceMultipleLabels.Horizontal.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.MultipleChoiceMultipleLabels.Vertical.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.MultipleFields.Default.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.Numerical.Default.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.Percentage.Default.tpl.html';
import './shared/odd/questionnaireTemplate/questionType/oddQuestionType.Ranking.Default.tpl.html';
import './shared/person/personDirective-card.tpl.html';
import './shared/person/personDirective-default.tpl.html';
import './shared/person/personDirective-eventFollowUp.tpl.html';
import './shared/person/personDirective-facet.tpl.html';
import './shared/person/personDirective-inline.tpl.html';
import './shared/person/personDirective-medium.tpl.html';
import './shared/person/personDirective-mini-calendar.tpl.html';
import './shared/person/personDirective-mini-emailAddress.tpl.html';
import './shared/person/personDirective-mini.tpl.html';
import './shared/person/personDirective-miniTwoLines.tpl.html';
import './shared/person/personDirective-navBoxItem-with-email.tpl.html';
import './shared/person/personDirective-navBoxItem.tpl.html';
import './shared/person/personDirective-navBoxItemNoTruncate.tpl.html';
import './shared/person/personDirective-navHeader.tpl.html';
import './shared/person/personDirective-searchBox.tpl.html';
import './shared/person/personDirective-small.tpl.html';
import './shared/person/personDirective-smallTwoLines.tpl.html';
import './shared/person/personDirective-threeLines.tpl.html';
import './shared/person/personDirective-twoLines.tpl.html';
import './shared/person/selectPersonModal.tpl.html';
import './shared/procedure/prcCannotDeleteProcedure.modal.tpl.html';
import './shared/procedure/prcIAMSystem.modal.item.tpl.html';
import './shared/procedure/prcInlineRef.BusinessUnit.tpl.html';
import './shared/procedure/prcInlineRef.Committee.tpl.html';
import './shared/procedure/prcInlineRef.CorporateRole.tpl.html';
import './shared/procedure/prcInlineRef.default.tpl.html';
import './shared/procedure/prcInlineRef.GlossaryTerm.tpl.html';
import './shared/procedure/prcInlineRef.IAMSystem.tpl.html';
import './shared/procedure/prcInlineRef.Procedure.tpl.html';
import './shared/procedure/prcInlineRef.Section.tpl.html';
import './shared/procedure/prcMarkdownToolbar.tpl.html';
import './shared/procedure/prcProcedure.modal.item.tpl.html';
import './shared/procedure/prcProcedure.nav-search.item.tpl.html';
import './shared/procedure/prcProcedure.nav-solr.item.tpl.html';
import './shared/procedure/prcProcedure.nav.item.tpl.html';
import './shared/procedure/prcResponsibility.full.tpl.html';
import './shared/procedure/prcResponsibility.modal.item.tpl.html';
import './shared/procedure/prcResponsibility.nav-solr.item.tpl.html';
import './shared/procedure/referenceType/prcAssignResponsibility.modal.tpl.html';
import './shared/procedure/referenceType/prcAttachment.modal.tpl.html';
import './shared/procedure/referenceType/prcBusinessUnit.modal.tpl.html';
import './shared/procedure/referenceType/prcCommittee.modal.tpl.html';
import './shared/procedure/referenceType/prcCorporateRole.modal.tpl.html';
import './shared/procedure/referenceType/prcCreateResponsibility.modal.tpl.html';
import './shared/procedure/referenceType/prcFootnote.modal.tpl.html';
import './shared/procedure/referenceType/prcIAMSystem.modal.tpl.html';
import './shared/procedure/referenceType/prcImageUpload.modal.tpl.html';
import './shared/procedure/referenceType/prcInlineReference.modal.tpl.html';
import './shared/procedure/referenceType/prcLookupAttributeValue.modal.tpl.html';
import './shared/procedure/referenceType/prcProcedure.modal.tpl.html';
import './shared/procedure/referenceType/prcReferenceType.modal.tpl.html';
import './shared/procedure/referenceType/prcSection.modal.tpl.html';
import './shared/procedure/referenceType/prcURL.modal.tpl.html';
import './shared/procedure/tooltip/prcTooltip.BusinessUnit.tpl.html';
import './shared/procedure/tooltip/prcTooltip.Committee.tpl.html';
import './shared/procedure/tooltip/prcTooltip.CorporateRole.tpl.html';
import './shared/procedure/tooltip/prcTooltip.GlossaryTerm.tpl.html';
import './shared/procedure/tooltip/prcTooltip.IAMSystem.tpl.html';
import './shared/procedure/tooltip/prcTooltip.Responsibility.tpl.html';
import './shared/searchBox/byRefineFacetGroup-controlStatus.tpl.html';
import './shared/searchBox/byRefineFacetGroup-default.tpl.html';
import './shared/searchBox/byRefineFacetGroup-initiativeCompletionStatus.tpl.html';
import './shared/searchBox/byRefineFacetGroup-publishedDate.tpl.html';
import './shared/searchBox/byResultType.tpl.html';
import './shared/searchBox/facetNavigation.tpl.html';
import './shared/searchBox/refineFacet-controlStatus.tpl.html';
import './shared/searchBox/refineFacet-default.tpl.html';
import './shared/searchBox/refineFacet-initiativeCompletionStatus.tpl.html';
import './shared/searchBox/refineFacet-person.tpl.html';
import './shared/searchBox/refineFacet-publishedDate.tpl.html';
import './shared/searchBox/refineFacet-riskRating.tpl.html';
import './shared/searchBox/searchActions.tpl.html';
import './shared/searchBox/searchBoxTriggerModal.tpl.html';
import './shared/searchBox/searchResults.tpl.html';
import './shared/searchBox/searchTypesLinks.tpl.html';
import './shared/searchV2/searchActionsSolr.tpl.html';
import './shared/searchV2/searchBox-businessPlanExplorer.tpl.html';
import './shared/searchV2/searchBox-default.tpl.html';
import './shared/searchV2/searchFacets-default.tpl.html';
import './shared/searchV2/searchPager-calendar-bottom.tpl.html';
import './shared/searchV2/searchPager-calendar.tpl.html';
import './shared/searchV2/searchPager-default.tpl.html';
import './shared/searchV2/searchPager-managePSSInitiatives.tpl.html';
import './shared/searchV2/searchPager-withGrouping.tpl.html';
import './shared/searchV2/searchResultsSolr.tpl.html';
import './shared/searchV2/searchSourceSelector-default.tpl.html';
